import { Directive, ViewContainerRef, TemplateRef, Input, OnInit, DoCheck, OnDestroy } from '@angular/core';

export interface MathContext {
	$implicit: number;
	root: number;
	power: number;
	exponent: number;
  }




@Directive({
	standalone : true,
	selector: '[appIteratorOf]'
})
export class IteratorDirective implements OnInit, DoCheck, OnDestroy {

	constructor(private container: ViewContainerRef,
		private template: TemplateRef<unknown>) { }

	@Input("appIteratorOf") dataSource: any;
	
	@Input("appIteratorOfStep") appIteratorOfStep = 1;	


	ngOnInit() {
		//this.updateContent();
	}

	

	ngDoCheck() {		
		this.updateContent();
	}	

	private updateContent() {
		this.container.clear();		
		if(!this.appIteratorOfStep)
			this.appIteratorOfStep = 1;

		const numIterations = Math.ceil(this.dataSource?.length / this.appIteratorOfStep);
		const matrix = [];

		for(let i = 0; i < numIterations; ++i)
		{			
			const startIndex = i * this.appIteratorOfStep;
			const endIndex = i * this.appIteratorOfStep + this.appIteratorOfStep;
			matrix.push(this.dataSource.slice(startIndex, endIndex));
			//const items = this.dataSource.slice(startIndex, endIndex);			
			// this.container.createEmbeddedView(this.template,
			// 	new IteratorDirectiveContext ( items ));
		}

		for(let i = 0 ; i < matrix.length; ++i)
		{
			this.container.createEmbeddedView(this.template,
				new IteratorDirectiveContext ( matrix[i] ));
		}
	}

	ngOnDestroy() {
        this.container.clear();
    }

}


// export interface IteratorDirectiveContext {
// 	$implicit: any[];
// 	iteration : number;	
// }

class IteratorDirectiveContext {

	constructor(public $implicit: any) 
	{

	}
}